<template>
	<v-modal>
		<template v-slot:header>
			<h1 v-html="service.names.singular + ' Introductions Configuration'"/>
		</template>
		<fieldset>
			<div>
				<div>
					<label><span>Panel </span>
						<div v-if="!form.options.panels.length" class="nothing-to-see-here">
							<p>No available panels.</p>
							<router-link
								:to="{name: 'panels.create'}"
								class="button button--text">Create A Panel</router-link>
						</div>
						<select v-else v-model="form.data.introduced_services[service.id].panel_id">
							<option :value="null" disabled selected>—</option>
							<option
								v-for="(panel, panelIndex) in form.options.panels"
								:key="panelIndex"
								:value="panel.id"
								v-html="panel.name"/>
						</select>
					</label>
					<!--							<template v-if="!form.data.introduced_services[service.id].panel_id">-->
					<!--								<label class="checkbox"><span>Use Campaign Configuration </span>-->
					<!--									<input-->
					<!--										type="checkbox"-->
					<!--										v-model="form.data.introduced_services[service.id].use_campaign">-->
					<!--									<div class="help-block">-->
					<!--										<p>This setting determines if configuration for this service is based on a campaign.</p>-->
					<!--									</div>-->
					<!--								</label>-->
					<!--								<template v-if="!form.data.introduced_services[service.id].use_campaign">-->
					<!--									<label-->
					<!--										v-if="service.force_variable_introducer_commissions || (service.variable_introducer_commissions && form.data.introduced_services[service.id].variable_commissions)">-->
					<!--										<span>Default Introducer Commission Fee For New Clients (Fixed £) </span>-->
					<!--										<input-->
					<!--											type="number"-->
					<!--											v-model="form.data.introduced_services[service.id].commission_price">-->
					<!--										<div class="help-block">-->
					<!--											<p>This setting determines the fixed instruction commission fee that the introducer will be owed and is paid by the instruction recipient in addition to the Calm instruction fee.</p>-->
					<!--										</div>-->
					<!--									</label>-->
					<!--									<label v-else>-->
					<!--										<span>Introducer Commission Fee For New Clients (Percent %) </span>-->
					<!--										<input-->
					<!--											type="number"-->
					<!--											v-model="form.data.introduced_services[service.id].commission_percent">-->
					<!--										<div class="help-block">-->
					<!--											<p>This setting determines the instruction commission fee that the introducer will be owed as a percentage of the Calm instruction fee and is paid out of the Calm instruction fee.</p>-->
					<!--										</div>-->
					<!--									</label>-->
					<!--									<label-->
					<!--										v-if="service.force_variable_introducer_commissions || (service.variable_introducer_commissions && form.data.introduced_services[service.id].variable_commissions)">-->
					<!--										<span>Default Introducer Commission Fee For Existing Clients (Fixed £) </span>-->
					<!--										<input-->
					<!--											type="number"-->
					<!--											v-model="form.data.introduced_services[service.id].commission_price_cross_sell">-->
					<!--										<div class="help-block">-->
					<!--											<p>This setting determines the fixed instruction commission fee that the introducer will be owed and is paid by the instruction recipient in addition to the Calm instruction fee.</p>-->
					<!--										</div>-->
					<!--									</label>-->
					<!--									<label v-else>-->
					<!--										<span>Introducer Commission Fee For Existing Clients (Percent %) </span>-->
					<!--										<input-->
					<!--											type="number"-->
					<!--											v-model="form.data.introduced_services[service.id].commission_percent_cross_sell">-->
					<!--										<div class="help-block">-->
					<!--											<p>This setting determines the instruction commission fee that the introducer will be owed as a percentage of the Calm instruction fee and is paid out of the Calm instruction fee.</p>-->
					<!--										</div>-->
					<!--									</label>-->
					<!--									<label><span-->
					<!--										v-html="'conveyancing' === service.key && !form.data.private_introducer ? 'Conveyancing Panel ' : 'Recipient '"></span>-->
					<!--										<div-->
					<!--											class="nothing-to-see-here"-->
					<!--											v-if="!viableVendors(service).length">-->
					<!--											<p>No service providers currently offering this service</p>-->
					<!--										</div>-->
					<!--										<template v-if="viableVendors(service).length">-->
					<!--											<checkbox-manager-->
					<!--												v-if="'conveyancing' === service.key && !form.data.private_introducer"-->
					<!--												:all-items="viableVendors(service)"-->
					<!--												:checked="checkedConveyancers"-->
					<!--												itemLabel="profile.name"-->
					<!--												helpBlock="Move the solicitors that <em>will be compared </em>into the right hand column or vice versa."-->
					<!--												v-on:valuesChanged="(items) => form.set('introduced_services.' + service.id + '.providers', items)"/>-->
					<!--											<select-->
					<!--												v-else-->
					<!--												v-model="form.data.introduced_services[service.id].providers">-->
					<!--												<option value="" disabled selected>—</option>-->
					<!--												<option-->
					<!--													v-for="(provider, providerIndex) in viableVendors(service)"-->
					<!--													:key="providerIndex"-->
					<!--													:value="provider.id"-->
					<!--													v-html="provider.profile.name"></option>-->
					<!--											</select>-->
					<!--										</template>-->
					<!--									</label>-->
					<!--								</template>-->
					<!--								<template v-if="form.data.introduced_services[service.id].use_campaign">-->
					<!--									<label><span>Campaign </span>-->
					<!--										<div-->
					<!--											class="nothing-to-see-here" v-if="!viableCampaigns(service).length">-->
					<!--											<div class="editorial">-->
					<!--												<p>No campaigns for this introducer/service configuration</p>-->
					<!--												<router-link-->
					<!--													:to="{name: 'campaigns.create'}"-->
					<!--													v-if="$can('createCampaigns')">Create a campaign</router-link>-->
					<!--											</div>-->
					<!--										</div>-->
					<!--										<select-->
					<!--											v-model="form.data.introduced_services[service.id].campaign_id"-->
					<!--											v-if="viableCampaigns(service).length">-->
					<!--											<option value="" selected>—</option>-->
					<!--											<option-->
					<!--												v-for="(campaign, campaignIndex) in viableCampaigns(service)"-->
					<!--												:value="campaign.id" v-html="campaign.name"></option>-->
					<!--										</select>-->
					<!--									</label>-->
					<!--								</template>-->
					<!--							</template>-->
				</div>
			</div>
		</fieldset>
		<template v-slot:footer>
			<ul class="actions">
				<li>
					<button class="button button--primary" @click.prevent="$vmodal.close()">Done</button>
				</li>
			</ul>
		</template>
	</v-modal>
</template>
<script>
export default {
	props: {
		form: {
			required: true,
			type: Object,
		},
		service: {
			required: true,
			type: Object,
		},
	},
};
</script>
